import { usePermissionOnSession } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Textarea from '../../../../components/form/Textarea'
import PlaceSelect from '../../../../containers/places/select/PlaceSelect'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import Select from '../../../../packages/kiti/components/form/Select'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'
import PlaceLevelSelect from '../../../../containers/placeLevels/select/PlaceLevelSelect'
import { useLevels } from '../_load/LevelsLoader'
import { clearFilterParams, getFilteredPlaceLevelTypes } from '../_helpers/filters'

const GeneralSection = () => {
  const { t } = useTranslation('editDynamicServiceOrders')
  const form = useForm()
  const [placeTypes] = usePlaceTypes()
  const levels = useLevels()
  const permissions = usePermissionOnSession()
  const { handleChangeIn } = useFormState()

  const placeLevelTypes = getFilteredPlaceLevelTypes(levels, placeTypes, permissions)

  const shouldDisablePlaceLevels = !form.configuration?.placeTypes?.length
  const levelIds = form.configuration?.placeTypes?.map(type => type.id)

  const handleAfterChange = value => {
    if (!value.length) {
      handleChangeIn(['configuration', 'placeLevels'], undefined)
    }
  }

  return (
    <>
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('generalSectionName')} field="name" />
        </Col>
        <Col width="50%" wrapOn="sm">
          <FormItem
            label={t('generalSectionChecklist')}
            field="checklist"
            Input={ChecklistSelect}
            filter={{ usages: ['serviceOrder'], includeDisabled: false }}
            canCreate
          />
        </Col>
        <Col width="50%" wrapOn="sm">
          <FormItem
            label={t('generalSectionType')}
            path={['configuration', 'placeTypes']}
            field="placeType"
            Input={Select}
            options={placeLevelTypes}
            afterChange={handleAfterChange}
            multiple
          />
        </Col>
        <Col width="50%" wrapOn="sm">
          <FormItem
            label={t('generalSectionLevel')}
            field="placeLevel"
            path={['configuration', 'placeLevels']}
            Input={PlaceLevelSelect}
            disabled={shouldDisablePlaceLevels}
            levelIds={levelIds}
            multiple
          />
        </Col>
        <Col width="100%" wrapOn="sm">
          <FormItem
            label={t('generalSectionPlace')}
            field="place"
            Input={PlaceSelect}
            filter={{
              lock: { checklistId: form.checklist?.id },
              ...clearFilterParams({
                types: form?.configuration?.placeTypes,
                placeLevelIds: form?.configuration?.placeLevels
              })
            }}
            ignoreDisable={false}
          />
        </Col>
        <Col width="100%" wrapOn="sm">
          <FormItem label={t('generalSectionDescription')} field="description" Input={Textarea} useMarkdown />
        </Col>
      </Grid>
    </>
  )
}

export default GeneralSection
